import { useBookEditor } from "../BookEditorProvider";

/**
 * Design mode — Turn 3 will own style samples and document controls.
 * Turn 1 surfaces shared book context so the mode switcher is real.
 */
export default function DesignMode() {
  const { book, bookStyles, documentSettings, chapters } = useBookEditor();
  const styleKeys = bookStyles && typeof bookStyles === "object" && !Array.isArray(bookStyles)
    ? Object.keys(bookStyles)
    : Array.isArray(bookStyles) ? bookStyles.map((s) => s.name || s.id) : [];

  return (
    <div className="book-editor-design-mode" data-testid="book-editor-design-mode">
      <div className="book-editor-placeholder-card">
        <h2>Design</h2>
        <p>
          Book-wide styles and page templates for{" "}
          <strong>{book?.title || "this book"}</strong>. Full design samples and
          style editors arrive in Turn 3 — this mode already shares the same bookId
          and style tokens as Write and Canvas.
        </p>
        <dl className="book-editor-meta-grid">
          <div>
            <dt>Chapters</dt>
            <dd>{chapters?.length || 0}</dd>
          </div>
          <div>
            <dt>Style tokens</dt>
            <dd>{styleKeys.length ? styleKeys.join(", ") : "Using writer defaults"}</dd>
          </div>
          <div>
            <dt>Trim</dt>
            <dd>{documentSettings?.trim?.name || book?.trim_size || "Not set (Turn 2)"}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
}
